module.exports = __webpack_public_path__ + "img/c3.9cef69d0.jpg";